import { Box, Link, TextField, Typography } from "@mui/material";
import styled from "styled-components";

export const FormCenteredBlackLink = styled(Link)`
  && {
    text-align: center;
    text-decoration: underline;
    color: #000000;
    height: 400;
    font-size: 1.125rem;
    line-height: 1.3rem;
  }
`;

export const FormRedLink = styled(Link)`
  && {
    color: #d71515;
    text-decoration: underline;
    height: 400;
    align-self: start;
    font-size: 1rem;
    line-height: 1.3rem;
  }
`;

export const FormTitle = styled(Typography)`
  && {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    variant: h4;
    font-weight: 600;
    font-size: 20px;
    align-self: baseline;
    line-height: 2.0525rem;
    font-family: "Work Sans", sans-serif;
  }
`;

export const StyledFormTextFieldContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledFormTextField = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      /* Cor da borda padrão */
      fieldset {
        border-color: #f5f5f5;
      }

      /* Cor da borda ao passar o mouse */
      &:hover fieldset {
        border-color: #707070;
      }

      /* Cor da borda quando o input está em foco */
      &.Mui-focused fieldset {
        border-color: #0c2856;
      }
    }
    .MuiInputBase-input {
      font-size: 0.875rem;
      line-height: 1.2rem;
      font-family: "Work Sans", sans-serif;
    }
    .MuiFormLabel-root {
      &.Mui-focused {
        color: #0c2856;
      }
    }
    .MuiFormHelperText-root {
      font-size: 0.875rem;
    }
  }
`;

export const StyledFormTextFieldLabel = styled(Typography)`
  && {
    color: #0c2856;
    font-weight: 500;
  }
`;

// Form Container

export const StyledForm = styled.form`
  && {
    position: relative;
    border-radius: 0.5rem;
    width: 33rem;
    padding: 2rem 2.5rem;
  }
`;

export const StyledBackLink = styled(Link)`
  && {
    cursor: "pointer";
    position: absolute;
    top: 0rem;
    left: -3.75rem;
  }
`;

export const StyledFieldsContainer = styled(Box)`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;
